var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-container" },
    [
      _c(
        "el-card",
        { attrs: { shadow: "none" } },
        [
          _c("span", { staticClass: "span-lable" }, [_vm._v("话机编号：")]),
          _c("el-input", {
            staticClass: "input-width",
            attrs: { placeholder: "请输入话机编号", size: "small" },
            model: {
              value: _vm.extenNumber,
              callback: function ($$v) {
                _vm.extenNumber = typeof $$v === "string" ? $$v.trim() : $$v
              },
              expression: "extenNumber",
            },
          }),
          _c("span", { staticClass: "span-lable ml-20" }, [
            _vm._v("话机类型："),
          ]),
          _c(
            "el-select",
            {
              staticClass: "input-width",
              attrs: { placeholder: "请选择话机类型", size: "small" },
              model: {
                value: _vm.type,
                callback: function ($$v) {
                  _vm.type = $$v
                },
                expression: "type",
              },
            },
            _vm._l(_vm.typeList, function (item, index) {
              return _c("el-option", {
                key: index,
                attrs: { label: item.name, value: item.value },
              })
            }),
            1
          ),
          _c("span", { staticClass: "span-lable ml-20" }, [
            _vm._v("话机区号："),
          ]),
          _c("el-input", {
            staticClass: "input-width",
            attrs: { placeholder: "请输入话机区号", size: "small" },
            model: {
              value: _vm.areaCode,
              callback: function ($$v) {
                _vm.areaCode = typeof $$v === "string" ? $$v.trim() : $$v
              },
              expression: "areaCode",
            },
          }),
          _c(
            "el-button",
            {
              staticClass: "ml-20",
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.getExtens },
            },
            [_vm._v("查询")]
          ),
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.clickReset } },
            [_vm._v("重置")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "div-table mt-10" },
        [
          _c("p", { staticClass: "p-title mt-10 mb-20" }, [
            _vm._v("话机管理列表 "),
            _c(
              "span",
              { staticClass: "fr" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "primary" },
                    on: { click: _vm.clickAdd },
                  },
                  [_vm._v("新增话机")]
                ),
              ],
              1
            ),
          ]),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "multipleTable",
              attrs: {
                data: _vm.tableData,
                "tooltip-effect": "dark",
                "header-cell-style": {
                  background: "#F2F4F7",
                  fontWeight: "400",
                  color: "#303133",
                },
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "话机编号" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(scope.row.extenNumber))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "areaCode", label: "话机区号" },
              }),
              _c("el-table-column", {
                attrs: { prop: "type", label: "话机类型" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(_vm._s(scope.row.type == 1 ? "分机" : "软电话")),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "话机密码" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(scope.row.password))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "status", label: "状态" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.bindStatus == "已绑定"
                          ? _c("play-status", { attrs: { type: "success" } }, [
                              _vm._v("已绑定"),
                            ])
                          : _c("play-status", { attrs: { type: "error" } }, [
                              _vm._v("未绑定"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "accountName",
                  label: "使用员工",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "userCnoNo",
                  label: "绑定座席",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.bindStatus !== "已绑定"
                          ? _c(
                              "el-button",
                              {
                                staticStyle: { color: "#374FB8" },
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.clickEdit(scope.row)
                                  },
                                },
                              },
                              [_vm._v("编辑")]
                            )
                          : _vm._e(),
                        scope.row.bindStatus !== "已绑定"
                          ? _c(
                              "el-button",
                              {
                                staticStyle: { color: "#999999" },
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteExten(scope.row)
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            )
                          : _vm._e(),
                        scope.row.bindStatus == "已绑定"
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  display: "inline-block",
                                  padding: "8px 0px",
                                },
                              },
                              [_vm._v("--")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("pagination", {
            staticStyle: { "margin-top": "80px" },
            attrs: {
              pageNum: _vm.pageNum,
              pageSize: _vm.pageSize,
              total: _vm.total,
            },
            on: {
              sizeChange: _vm.handleSizeChange,
              currentChange: _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogVisible,
            width: "640px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "demo-ruleForm",
              attrs: {
                model: _vm.ruleForm,
                rules: _vm.rules,
                "label-width": "130px",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  class: _vm.dialogTitle !== "编辑" ? "edit-input" : "",
                  attrs: { label: "话机编号：", prop: "extenNumber" },
                },
                [
                  _vm.dialogTitle !== "编辑"
                    ? _c(
                        "span",
                        {
                          staticStyle: {
                            display: "inline-block",
                            width: "40px",
                          },
                        },
                        [_vm._v(_vm._s(_vm.accountCallCode))]
                      )
                    : _vm._e(),
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.dialogTitle == "编辑",
                      size: "small",
                      placeholder: "请输入话机编号",
                    },
                    on: {
                      input: function ($event) {
                        _vm.ruleForm.extenNumber =
                          _vm.ruleForm.extenNumber.replace(/[^\d]/g, "")
                      },
                    },
                    model: {
                      value: _vm.ruleForm.extenNumber,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "extenNumber", $$v)
                      },
                      expression: "ruleForm.extenNumber",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "话机密码：", prop: "password" } },
                [
                  _c("el-input", {
                    attrs: { size: "small", placeholder: "请输入话机密码" },
                    on: {
                      input: function ($event) {
                        _vm.ruleForm.password = _vm.ruleForm.password.replace(
                          /[^\d]/g,
                          ""
                        )
                      },
                    },
                    model: {
                      value: _vm.ruleForm.password,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "password", $$v)
                      },
                      expression: "ruleForm.password",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "区号：", prop: "areaCode" } },
                [
                  _c("el-input", {
                    attrs: { size: "small", placeholder: "请输入区号" },
                    on: {
                      input: function ($event) {
                        _vm.ruleForm.areaCode = _vm.ruleForm.areaCode.replace(
                          /[^\d]/g,
                          ""
                        )
                      },
                    },
                    model: {
                      value: _vm.ruleForm.areaCode,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.ruleForm,
                          "areaCode",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "ruleForm.areaCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "话机类型：", prop: "type" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { size: "small", placeholder: "请选择话机类型" },
                      on: { change: _vm.changeType },
                      model: {
                        value: _vm.ruleForm.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "type", $$v)
                        },
                        expression: "ruleForm.type",
                      },
                    },
                    _vm._l(_vm.typeList, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.name, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "语音编码：", prop: "allow" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { size: "small", placeholder: "请选择语音编码" },
                      model: {
                        value: _vm.ruleForm.allow,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "allow", $$v)
                        },
                        expression: "ruleForm.allow",
                      },
                    },
                    _vm._l(_vm.codeList, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.name, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.clickSubmit } },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }